import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export const SocialProof = () => {
  return <section className="bg-gray-50 px-4 py-8 md:py-16 lg:px-8" data-id="element-219">
      <div className="mx-auto max-w-3xl" data-id="element-220">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center text-center" data-id="element-221">
          {/* Testimonial Text Only */}
          <div className="space-y-6" data-id="element-222">
            <div className="flex justify-center space-x-1" data-id="element-223">
              {[1, 2, 3, 4, 5].map(star => <Star key={star} className="h-6 w-6 fill-yellow-400 text-yellow-400" data-id="element-224" />)}
            </div>

            <h3 className="font-serif text-2xl font-bold text-text-dark" data-id="element-225">
              "Definitely worth it!"
            </h3>

            <blockquote className="text-lg italic text-text-dark/80" data-id="element-226">
              "We're so glad we went ahead with this purchase and prep. The
              toughest part of dinner now is just remembering to take the bag
              out. So worth it!!"
            </blockquote>

            <p className="font-bold text-terracotta" data-id="element-227">
              — Elena, Peaceful Dinner Protocol user.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};